type Keyword = {
    keywordId: number
    name: string
}

type KeywordSection = {
    keywordSectionId: number
    keywords: Keyword[]
    name: string
}

type ExerciseMetaSectionProps = {
    keywordSections: KeywordSection[]
}

const renderIcon = (keywordName, keywords = []) => {
    switch (keywordName) {
        case 'Music':
            return keywords?.length ? (
                <div className="flex items-center">
                    <div className="w-[30px] mr-3 h-[50px] flex items-center justify-center">
                        <i className="fas fa-music text-2xl text-gray-400"></i>
                    </div>
                    {keywords?.map((k, idx) => (
                        <span className="font-medium" key={idx}>
                            {k.name}
                            {keywords.length > 1 &&
                            idx >= 0 &&
                            idx + 1 !== keywords.length ? (
                                <span className="mr-1">,</span>
                            ) : (
                                ''
                            )}
                        </span>
                    ))}
                </div>
            ) : null
        case 'Equipment Needed':
            return keywords?.length ? (
                <div className="flex items-center">
                    <div className="w-[30px] mr-3 h-[50px] flex items-center justify-center">
                        <i className="fad fa-dumbbell text-2xl text-gray-400"></i>
                    </div>
                    {keywords?.map((k, idx) => (
                        <span className="font-medium" key={idx}>
                            {k.name}
                            {keywords.length > 1 &&
                            idx >= 0 &&
                            idx + 1 !== keywords.length ? (
                                <span className="mr-1">,</span>
                            ) : (
                                ''
                            )}
                        </span>
                    ))}
                </div>
            ) : null
        case 'Target Area':
            return keywords?.length ? (
                <div className="flex items-center">
                    <div className="w-[30px] mr-3 h-[50px] flex items-center justify-center">
                        <i className="fak fa-body text-2xl text-gray-400"></i>
                    </div>
                    {keywords?.map((k, idx) => (
                        <span className="font-medium" key={idx}>
                            {k.name}
                            {keywords.length > 1 &&
                            idx >= 0 &&
                            idx + 1 !== keywords.length ? (
                                <span className="mr-1">,</span>
                            ) : (
                                ' '
                            )}
                        </span>
                    ))}
                </div>
            ) : null
        case 'Age Appropriateness':
            return keywords?.length ? (
                <div className="flex items-center">
                    <div className="w-[30px] mr-3 h-[50px] flex items-center justify-center">
                        <i className="fas fa-address-card text-2xl text-gray-400"></i>
                    </div>
                    {keywords?.map((k, idx) => (
                        <span className="font-medium" key={idx}>
                            {k.name}
                            {keywords.length > 1 &&
                            idx >= 0 &&
                            idx + 1 !== keywords.length ? (
                                <span className="mr-1">,</span>
                            ) : (
                                ''
                            )}
                        </span>
                    ))}
                </div>
            ) : null
        default:
            return null
    }
}

export const ExerciseMetaSection = ({ keywordSections }: ExerciseMetaSectionProps) => {
    return (
        <div className="max-w-screen-fullHd mx-auto px-5 sm:px-10 mb-12">
            {keywordSections?.map((keyword, idx) => {
                return <div key={idx}>{renderIcon(keyword.name, keyword.keywords)}</div>
            }) ?? null}
        </div>
    )
}
